export default {

    computed: {
        // 折扣类型
        getDisacountType() {
            return [{
                label: this.$t('bi.work.task_org_id', { defaultValue: '组织' }),
                value: 10,
            },
            // {
            //     label: this.$t('fbb.account.mixin_org_project', { defaultValue: '组织+项目' }),
            //     value: 40,

            // },
            {
                label: this.$t('fbb.account.mixin_org_carrier', { defaultValue: '组织+承运商服务' }),
                value: 20,

            }, {
                label: this.$t('fbb.account.mixin_discount_all', { defaultValue: '组织+承运商服务+重量区间' }),
                value: 30,

            }, {
                label: this.$t('fbb.account.mixin_discount_zone', { defaultValue: '组织+承运商服务+重量区间+Zone' }),
                value: 50,

            }, {
                label: this.$t('fbb.account.mixin_org_lineid_all', { defaultValue: '组织+项目+承运商服务' }),
                value: 21,

            }, {
                label: this.$t('fbb.account.mixin_lineidseivice_all', { defaultValue: '组织+项目+承运商服务+重量区间' }),
                value: 31,

            }]
        },
        // 偏远地区类型
        getRemotezipType() {
            return [
                {
                    label: this.$t('fbb.account.mixin_normal', { defaultValue: '正常范围' }),
                    value: 'NORMAL',
                    number: 0,
                }, {
                    label: this.$t('fbb.account.mixin_noremote', { defaultValue: '一般偏远' }),
                    value: 'NOREMOTE',
                    number: 1,
                }, {
                    label: this.$t('fbb.account.mixin_remote', { defaultValue: '超偏远' }),
                    value: 'REMOTE',
                    number: 2,
                }, {
                    label: this.$t('fbb.account.mixin_hawaii', { defaultValue: '夏威夷地区' }),
                    value: 'HAWAII',
                    number: 4,
                }, {
                    label: this.$t('fbb.account.mixin_alaska', { defaultValue: '阿拉斯加地区' }),
                    value: 'ALASKA',
                    number: 3,
                }, {
                    label: 'Remote48',
                    value: 'REMOTE48',
                    number: 5,
                }, {
                    label: 'Remote',
                    value: 'REMOTE_FARAWAY',
                    number: 6,
                }, {
                    label: 'Super Remote',
                    value: 'SUPER_REMOTE_FARAWAY',
                    number: 7,
                }]
        },
        logcolumn() {
            return [
                {
                    title: this.$t('global.common.operator', { defaultValue: '操作人' }),
                    key: "updatedName",
                },
                {
                    title: this.$t('global.common.operate_type', { defaultValue: '操作类型' }),
                    key: "operateType",
                    render: (h, { row }) => {
                        return row.operateType == 1 ? this.$t('global.common.create', { defaultValue: '创建' }) : this.$t('fbb.account.mixin_update', { defaultValue: '修改' })
                    }
                },
                {
                    title: this.$t('fbb.basicdata.carrier_change_field', { defaultValue: '更改字段' }),
                },
                {
                    title: this.$t('fbb.basicdata.carrier_change_before', { defaultValue: '更改前值' }),
                    key: "beforeValue",
                },
                {
                    title: this.$t('fbb.basicdata.carrier_change_after', { defaultValue: '更改后值' }),
                    key: "afterValue",
                },
                {
                    title: this.$t('global.common.createdtime', { defaultValue: '创建时间' }),
                    key: "createdAt",
                },
            ]
        },
        morelogcolumn() {
            return [
                {
                    title: this.$t('global.common.operator', { defaultValue: '操作人' }),
                    key: "opUserName",
                },
                {
                    title: this.$t('global.common.operate_type', { defaultValue: '操作类型' }),
                    key: "opAction",
                },
                {
                    title: this.$t('fbb.basicdata.carrier_change_field', { defaultValue: '更改字段' }),
                    key: "changeField",
                },
                {
                    title: this.$t('fbb.basicdata.carrier_change_before', { defaultValue: '更改前值' }),
                    key: "beforeChange",
                },
                {
                    title: this.$t('fbb.basicdata.carrier_change_after', { defaultValue: '更改后值' }),
                    key: "afterChange",
                },
                {
                    title: this.$t('global.common.createdtime', { defaultValue: '创建时间' }),
                    key: "opAt",
                },
            ]
        }
    },
}
